var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUnpin = function SvgIconUnpin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-unpin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.667 1.667 16.666 16.667M10 14.167v4.167",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5v1.467a1.667 1.667 0 0 1-.925 1.491l-1.484.75a1.667 1.667 0 0 0-.925 1.492v1.467h10",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5v1.467a1.667 1.667 0 0 1-.925 1.491l-1.484.75a1.667 1.667 0 0 0-.925 1.492v1.467h10",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.784V5h.834a1.666 1.666 0 1 0 0-3.333H6.575",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.784V5h.834a1.666 1.666 0 1 0 0-3.333H6.575",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-unpin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconUnpin;